import { Component, ElementRef, Input, OnInit, OnDestroy, NgZone, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import * as monaco from 'monaco-editor';

import { initializeMonaco } from './monaco-bootstrap';
initializeMonaco();

// import monacoTheme from 'monaco-editor-themes/GitHub.json';

import { DiffEditorModel } from '../scope-snapshot-inheritances/scope-snapshot-inheritances.component';

@Component({
	selector: 'app-monaco-diff-editor',
	templateUrl: './monaco-diff-editor.component.html',
	styleUrls: [`./monaco-diff-editor.component.scss`]
})
export class MonacoDiffEditorComponent implements OnDestroy, OnInit {
	@Input()	originalModel!: DiffEditorModel;
	@Input()	modifiedModel!: DiffEditorModel;
	@Output('new-diff-editor') newDiffEditorEvent: EventEmitter<monaco.editor.IStandaloneDiffEditor | undefined> = new EventEmitter();

  diffEditor?: monaco.editor.IStandaloneDiffEditor;
	// customMonacoLoaded = false;
	
	// @Input() language = 'json';
	@ViewChild('diffContainer', { static: true }) diffContainer!: ElementRef<HTMLDivElement>;

	constructor(private zone: NgZone) {}

	ngOnInit(): void {
		// monaco.editor.defineTheme(
		// 	'scoperoot-monaco-diff-theme',
		// 	monacoTheme as monaco.editor.IStandaloneThemeData
		// );

		// Create the diff editor itself
		this.diffEditor = monaco.editor.createDiffEditor(
			this.diffContainer.nativeElement,
			{
				theme: 'vs-light',
				// theme: 'vs-dark',
				// theme: 'scoperoot-monaco-diff-theme',
				automaticLayout: true,
				renderSideBySide: true,  // set false for inline mode
				readOnly: true,
				wordWrap: "on"
			}
		);

		// Attach models to diff editor
		this.diffEditor.setModel({
			original: monaco.editor.createModel(this.originalModel.code, this.originalModel.language),
			modified: monaco.editor.createModel(this.modifiedModel.code, this.modifiedModel.language),
		});

		this.diffEditor.revealFirstDiff(); // Scroll to first diff to help the user out. Otherwise, if you have a long config, the user would have to manually scroll a long way to find the first diff. 
		this.newDiffEditorEvent.emit(this.diffEditor);
	}

	ngOnDestroy() {
		if (this.diffEditor) {
			const model = this.diffEditor.getModel();
			this.diffEditor.setModel(null);
			this.diffEditor.dispose();
			model?.original.dispose();
			model?.modified.dispose();
			
			this.newDiffEditorEvent.emit(undefined);
		}
	}
}
